import styled from '@emotion/styled';
import { memo } from 'react';
export const MarketView = memo(function MarketView() {
    return <classes.container>綜合報價</classes.container>;
});
const classes = {
    container: styled.div ``,
};
